module.exports = __webpack_public_path__ + "media/images/bg/22-67e279d41a6fc8e3be11142bc5fa6588.jpg";